import React from "react";
import PropTypes from "prop-types";
import classes from "./search.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { onSubmitForm } from "../../../../store/actions/header.js";
import { useForm } from "react-hook-form";
import Input from "../../../UI/input/input.js";

const Search = (props) => {
  const dispatch = useDispatch();
  const input = useSelector((state) => state.header.search);
  const { register, handleSubmit, errors } = useForm({ mode: "onChange" });
  const onSubmit = (data) => dispatch(onSubmitForm(input, data));

  return (
    <form className={classes.header__search} onSubmit={handleSubmit(onSubmit)}>
      <div className={classes.search__wrapper}>
        <Input
          errors={errors}
          register={register}
          type={input.type}
          name={input.name}
          placeholder={input.placeholder}
        />
        <button
          className={classes.search__submit}
          disabled={errors[input.name] ? true : false}
        >
          <FontAwesomeIcon icon="search" />
        </button>
      </div>
    </form>
  );
};

Search.propTypes = {
  //products: PropTypes.array
};

export default Search;
